var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBarbell = function SvgIconBarbell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.375 11V6a1.75 1.75 0 0 0-1.75-1.75h-2.25A1.75 1.75 0 0 0 4.625 6v.5H3a1.75 1.75 0 0 0-1.75 1.75V11h-.125a1 1 0 1 0 0 2h.125v2.75A1.75 1.75 0 0 0 3 17.5h1.625v.5c0 .966.784 1.75 1.75 1.75h2.25a1.75 1.75 0 0 0 1.75-1.75v-5h3.25v5c0 .966.784 1.75 1.75 1.75h2.25a1.75 1.75 0 0 0 1.75-1.75v-.5H21a1.75 1.75 0 0 0 1.75-1.75V13h.125a1 1 0 1 0 0-2h-.125V8.25A1.75 1.75 0 0 0 21 6.5h-1.625V6a1.75 1.75 0 0 0-1.75-1.75h-2.25A1.75 1.75 0 0 0 13.625 6v5zm-3.75-4.75v11.5h1.75V6.25zM3.25 15.5h1.375v-7H3.25zm17.5-7v7h-1.375v-7zm-5.125 9.25h1.75V6.25h-1.75z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBarbell;